import { createDynamicMiddlewares } from 'redux-dynamic-middlewares';

const sportsbookDynamicMiddlewares = createDynamicMiddlewares(); // eslint-disable-line
export default sportsbookDynamicMiddlewares;
